(function(){
  "use strict";

  /* ---------- Drawer helpers (cart / mobile menu) ---------- */
  function openDrawer(el){
    if(!el) return;
    el.hidden = false;
    setTimeout(function(){ el.classList.add('is-open'); }, 10);
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(el){
    if(!el) return;
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var panel = el.querySelector('.drawer__panel');
    var done = function(){ el.hidden = true; panel.removeEventListener('transitionend', done); };
    if(panel){ panel.addEventListener('transitionend', done); } else { el.hidden = true; }
  }

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-open]')){ openDrawer(cartDrawer); }
    if(e.target.closest('[data-cart-close]')){ closeDrawer(cartDrawer); }
    if(e.target.closest('[data-mobile-menu-open]')){ openDrawer(mobileMenu); }
    if(e.target.closest('[data-mobile-menu-close]')){ closeDrawer(mobileMenu); }
  });

  /* ---------- Sticky header hide on scroll down ---------- */
  var header = document.querySelector('[data-site-header]');
  var lastScroll = window.scrollY;
  window.addEventListener('scroll', function(){
    if(!header) return;
    var current = window.scrollY;
    if(current > lastScroll && current > 120){ header.classList.add('is-hidden'); }
    else { header.classList.remove('is-hidden'); }
    lastScroll = current;
  }, { passive: true });

  /* ---------- Announcement bar auto-rotate ---------- */
  var track = document.querySelector('[data-announcement-bar] .announcement-bar__track');
  if(track){
    var items = track.children.length;
    if(items > 1){
      var idx = 0;
      setInterval(function(){
        idx = (idx + 1) % items;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      }, 4000);
    }
  }

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window && revealEls.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* ---------- Cart AJAX ---------- */
  function refreshCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    });
  }

  function renderCartDrawer(html){
    if(!cartDrawer) return;
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var newDrawer = temp.querySelector('[data-cart-drawer]');
    if(newDrawer){
      cartDrawer.innerHTML = newDrawer.innerHTML;
    }
  }

  function cartRequest(url, body){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){ return r.json(); }).then(function(data){
      if(data.sections && data.sections['cart-drawer']){ renderCartDrawer(data.sections['cart-drawer']); }
      refreshCartCount();
      openDrawer(cartDrawer);
      return data;
    });
  }

  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-product-form]');
    if(!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var submitBtn = form.querySelector('[type="submit"]');
    if(submitBtn) submitBtn.disabled = true;
    cartRequest('/cart/add.js', {
      items: [{ id: idInput ? idInput.value : null, quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 }],
      sections: 'cart-drawer'
    }).catch(function(){}).finally(function(){ if(submitBtn) submitBtn.disabled = false; });
  });

  document.addEventListener('click', function(e){
    var quickBtn = e.target.closest('[data-quick-add-id]');
    if(quickBtn){
      cartRequest('/cart/add.js', { items: [{ id: quickBtn.getAttribute('data-quick-add-id'), quantity: 1 }], sections: 'cart-drawer' });
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if(removeBtn){
      var line = removeBtn.closest('[data-line]').getAttribute('data-line');
      cartRequest('/cart/change.js', { line: parseInt(line, 10), quantity: 0, sections: 'cart-drawer' });
    }

    var incBtn = e.target.closest('[data-qty-increase]');
    var decBtn = e.target.closest('[data-qty-decrease]');
    if(incBtn || decBtn){
      var item = (incBtn || decBtn).closest('[data-line]');
      var lineNum = parseInt(item.getAttribute('data-line'), 10);
      var valueEl = item.querySelector('[data-qty-value]');
      var current = parseInt(valueEl.textContent, 10) || 1;
      var next = incBtn ? current + 1 : Math.max(0, current - 1);
      cartRequest('/cart/change.js', { line: lineNum, quantity: next, sections: 'cart-drawer' });
    }
  });

  /* ---------- PDP: quantity stepper ---------- */
  document.addEventListener('click', function(e){
    var plus = e.target.closest('[data-qty-plus]');
    var minus = e.target.closest('[data-qty-minus]');
    if(plus || minus){
      var wrap = (plus || minus).closest('[data-qty-stepper]');
      var input = wrap.querySelector('input');
      var val = parseInt(input.value, 10) || 1;
      input.value = plus ? val + 1 : Math.max(1, val - 1);
    }
  });

  /* ---------- PDP: gallery thumbnails ---------- */
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('[data-thumb]');
    if(!thumb) return;
    var gallery = thumb.closest('[data-pdp-gallery]');
    var mainImg = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    mainImg.src = thumb.getAttribute('data-full-src');
  });

  /* ---------- PDP: variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var dataEl = form.querySelector('[data-variants-json]');
    if(!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var comparePriceEl = form.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add-button]');
    var soldOutText = 'Sold Out';
    var addText = 'Add to Cart';

    function money(cents){
      return '$' + (cents / 100).toFixed(2) + ' AUD';
    }

    function selectedOptions(){
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function(group){
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var active = group.querySelector('.is-selected');
        opts[idx] = active ? active.getAttribute('data-value') : null;
      });
      return opts;
    }

    function findVariant(){
      var opts = selectedOptions();
      return variants.find(function(v){
        return v.options.every(function(o, i){ return o === opts[i]; });
      });
    }

    function updateAvailability(){
      var opts = selectedOptions();
      form.querySelectorAll('[data-option-index]').forEach(function(group){
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('[data-value]').forEach(function(btn){
          var testOpts = opts.slice();
          testOpts[idx] = btn.getAttribute('data-value');
          var match = variants.find(function(v){ return v.options.every(function(o,i){ return testOpts[i] == null || o === testOpts[i]; }); });
          btn.disabled = !match || !match.available;
        });
      });
    }

    function updateMobileBar(variant){
      var bar = document.querySelector('[data-mobile-buy-bar]');
      if(!bar) return;
      var priceSpan = bar.querySelector('[data-mobile-buy-price]');
      if(priceSpan) priceSpan.textContent = money(variant.price);
    }

    function render(){
      var variant = findVariant();
      if(!variant) return;
      idInput.value = variant.id;
      if(priceEl) priceEl.textContent = money(variant.price);
      if(comparePriceEl){
        if(variant.compare_at_price && variant.compare_at_price > variant.price){
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else { comparePriceEl.hidden = true; }
      }
      if(addBtn){
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addText : soldOutText;
      }
      updateAvailability();
      updateMobileBar(variant);
    }

    form.addEventListener('click', function(e){
      var opt = e.target.closest('[data-value]');
      if(!opt || opt.disabled) return;
      var group = opt.closest('[data-option-index]');
      group.querySelectorAll('[data-value]').forEach(function(b){ b.classList.remove('is-selected'); });
      opt.classList.add('is-selected');
      render();
    });

    render();
  });

  /* ---------- Mobile sticky buy bar (PDP only) ---------- */
  var buySource = document.querySelector('[data-mobile-buy-source]');
  var buyBar = document.querySelector('[data-mobile-buy-bar]');
  var mainForm = document.querySelector('[data-product-form]');
  if(buySource && buyBar && mainForm){
    var titleEl = buyBar.querySelector('[data-mobile-buy-title]');
    var priceEl2 = buyBar.querySelector('[data-mobile-buy-price]');
    var addBtn2 = buyBar.querySelector('[data-mobile-buy-add]');
    if(titleEl) titleEl.textContent = buySource.getAttribute('data-title') || '';
    var mainPrice = mainForm.querySelector('[data-price]');
    if(priceEl2 && mainPrice) priceEl2.textContent = mainPrice.textContent;

    if(addBtn2){
      addBtn2.addEventListener('click', function(){
        if(mainForm.requestSubmit){ mainForm.requestSubmit(); }
        else { mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
      });
    }

    var addButtonInMain = mainForm.querySelector('[data-add-button]');
    if(addButtonInMain && 'IntersectionObserver' in window){
      var barObserver = new IntersectionObserver(function(entries){
        entries[0].isIntersecting ? buyBar.classList.remove('is-visible') : buyBar.classList.add('is-visible');
      }, { rootMargin: '0px 0px -10% 0px' });
      barObserver.observe(addButtonInMain);
    }
  }

  /* ---------- Swipeable product story carousel ---------- */
  document.querySelectorAll('.story-carousel').forEach(function(carousel){
    var track = carousel.querySelector('[data-carousel-track]');
    if(!track) return;
    var slides = Array.from(track.children);
    var dots = carousel.querySelectorAll('[data-carousel-dot]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var current = 0;

    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    dots.forEach(function(dot, i){
      dot.addEventListener('click', function(){ goTo(i); });
    });
    if(prevBtn) prevBtn.addEventListener('click', function(){ goTo(current - 1); });
    if(nextBtn) nextBtn.addEventListener('click', function(){ goTo(current + 1); });

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            current = slides.indexOf(entry.target);
            dots.forEach(function(d, i){ d.classList.toggle('is-active', i === current); });
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function(s){ io.observe(s); });
    }
  });

})();
